import { useState, useEffect, useContext } from 'react';
import { Typography, FormControlLabel, Paper } from '@mui/material';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '../../../../../components/common/Accordion';
import {
  TextField,
  Grid,
  Button,
  Checkbox,
} from '../../../../../components/common';
import texts from '../../../../../assets/texts';
import { emailValidator, loan } from '../../../../../utils';
import AccordionFormContext from '../../../../../store/accordion-form-context';

export default function AdditionalConsents(props) {
  const accordionCTX = useContext(AccordionFormContext);
  const [allPermissionsCheckbox, setAllPermissionsCheckbox] = useState(false);
  const [secondStageButtonDisabled, setSecondStageButtonDisabled] =
    useState(true);

  const handleCheckboxChange = (event) => {
    switch (event.target.name) {
      case 'allPermissionsCheckbox':
        if (event.target.checked) {
          setAllCheckboxesTrue();
        } else {
          setAllCheckboxesFalse();
        }
        break;
      case 'dataProcessingPermission':
        accordionCTX.changeFormValue(
          'dataProcessingPermission',
          event.target.checked
        );
        break;
      case 'agrowePermission':
        accordionCTX.changeFormValue('agrowePermission', event.target.checked);
        break;
      case 'bankPermission':
        accordionCTX.changeFormValue('bankPermission', event.target.checked);
        break;
      default:
    }
  };

  const submitForm = async () => {
    accordionCTX.changeStatus('LOADING', true);
    const body = {
      phoneNumber: accordionCTX.form.phoneNumber,
      email: accordionCTX.form.email,
      dataProcessingPermission: accordionCTX.form.dataProcessingPermission,
      bankPermission: accordionCTX.form.bankPermission,
      agrowePermission: accordionCTX.form.agrowePermission,
    };
    await loan
      .sendLoanApplication(body)
      .then((result) => {
        if (result.data != null) {
          accordionCTX.changeFormValue('loanApplicationID', result.data);
        }
        accordionCTX.changeStatus('LOADING', false);
        accordionCTX.changeNavigation('UNLOCK', 'panel3');
      })
      .catch((err) => {});
  };

  const setAllCheckboxesTrue = () => {
    setAllPermissionsCheckbox(true);
    accordionCTX.changeFormValue('dataProcessingPermission', true);
    accordionCTX.changeFormValue('agrowePermission', true);
    accordionCTX.changeFormValue('bankPermission', true);
  };

  const setAllCheckboxesFalse = () => {
    setAllPermissionsCheckbox(false);
    accordionCTX.changeFormValue('dataProcessingPermission', false);
    accordionCTX.changeFormValue('agrowePermission', false);
    accordionCTX.changeFormValue('bankPermission', false);
  };

  useEffect(() => {
    if (
      !(
        accordionCTX.form.loanAmount.length < 1 ||
        accordionCTX.form.loanType.length < 1 ||
        accordionCTX.form.isTakingDirectPayments.length < 1 ||
        parseInt(accordionCTX.form.loanAmount) < 999 ||
        accordionCTX.form.email.length < 1 ||
        accordionCTX.form.phoneNumber.length < 1
      ) &&
      Number.isInteger(parseInt(accordionCTX.form.loanAmount)) &&
      accordionCTX.form.dataProcessingPermission &&
      accordionCTX.form.agrowePermission &&
      accordionCTX.form.bankPermission &&
      accordionCTX.form.phoneNumber.length >= 9 &&
      accordionCTX.form.email.length > 0 &&
      emailValidator(accordionCTX.form.email)
    ) {
      setSecondStageButtonDisabled(false);
    } else {
      setSecondStageButtonDisabled(true);
    }
  }, [
    accordionCTX.form.loanAmount,
    accordionCTX.form.loanType,
    accordionCTX.form.loanLength,
    accordionCTX.form.isTakingDirectPayments,
    accordionCTX.form.email,
    accordionCTX.form.phoneNumber,
    accordionCTX.form.dataProcessingPermission,
    accordionCTX.form.agrowePermission,
    accordionCTX.form.bankPermission,
  ]);

  return (
    <Accordion
      square
      expanded={accordionCTX.navigation.expanded === 'panel2'}
      onChange={() => accordionCTX.changeNavigation('CHANGE', 'panel2')}
    >
      <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
        <h1>2. Dodatkowe zgody</h1>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          <Grid
            infoCard
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            component={Paper}
          >
            <Typography variant="h4">
              Gratulujemy! Mamy kredyt który odpowiada Twoim potrzebom.
            </Typography>
          </Grid>
          <Grid infoCard topMargin item xs={12} component={Paper}>
            <Typography variant="h5">
              {texts.accordionFormAdditionalPermissions}
            </Typography>
          </Grid>
          <Grid topMargin item xs={12}>
            <TextField
              variant="outlined"
              margin="normal"
              value={accordionCTX.form.email}
              required
              fullWidth
              id="email"
              label="Podaj swój adres email"
              name="email"
              onChange={(event) =>
                accordionCTX.changeFormValue('email', event.target.value)
              }
              autoFocus
              error={
                accordionCTX.form.email.length > 0 &&
                !emailValidator(accordionCTX.form.email)
              }
              helperText={
                accordionCTX.form.email.length > 0 &&
                !emailValidator(accordionCTX.form.email) &&
                'Nieprawidłowy adres email!'
              }
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <TextField
              variant="outlined"
              value={accordionCTX.form.phoneNumber}
              margin="normal"
              required
              fullWidth
              id="phone"
              label="Podaj swój numer telefonu"
              name="phone"
              inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                maxLength: 9,
              }}
              onChange={(e) => {
                if (
                  e.target.value === '' ||
                  /^[0-9\b]+$/.test(e.target.value)
                ) {
                  accordionCTX.changeFormValue('phoneNumber', e.target.value);
                }
              }}
              error={
                accordionCTX.form.phoneNumber.length > 0 &&
                accordionCTX.form.phoneNumber.length < 9
              }
              helperText={
                accordionCTX.form.phoneNumber.length < 9 &&
                'Niepoprawny numer telefonu!'
              }
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  required
                  onChange={handleCheckboxChange}
                  checked={allPermissionsCheckbox}
                  inputProps={{ 'aria-label': 'controlled' }}
                  name="allPermissionsCheckbox"
                />
              }
              label={
                allPermissionsCheckbox
                  ? 'Odznacz wszystkie'
                  : 'Zaznacz wszystkie'
              }
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  required
                  onChange={handleCheckboxChange}
                  checked={accordionCTX.form.dataProcessingPermission}
                  inputProps={{ 'aria-label': 'controlled' }}
                  name="dataProcessingPermission"
                />
              }
              label={texts.accordionFormAdditionalPermissionsCheckbox1}
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  required
                  onChange={handleCheckboxChange}
                  checked={accordionCTX.form.agrowePermission}
                  inputProps={{ 'aria-label': 'controlled' }}
                  name="agrowePermission"
                />
              }
              label={texts.accordionFormAdditionalPermissionsCheckbox2}
            />
          </Grid>
          <Grid topMargin item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  required
                  onChange={handleCheckboxChange}
                  checked={accordionCTX.form.bankPermission}
                  inputProps={{ 'aria-label': 'controlled' }}
                  name="bankPermission"
                />
              }
              label={texts.accordionFormAdditionalPermissionsCheckbox3}
            />
          </Grid>
          <Grid
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            sx={{ textAlign: 'center' }}
          >
            <Typography variant="subtitle1">
              {texts.accordionFormAdditionalPermissionsUserDataInfo}
            </Typography>
          </Grid>
          <Grid topMargin container justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              disabled={secondStageButtonDisabled}
              onClick={submitForm}
            >
              Potwierdź współpracę
            </Button>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
